export const YmEventGoals = {
    SHOW_BETCITY: 'logo_bet_show',
    SHARE_VK: 'VK',
    SHARE_OK: 'OK',
    FURTHER: 'further',
    PAUSE_PLAY: 'pause_play'
};
